import { default as TableNormal } from './TableNormal';

const EXPORT = {
    TableNormal,
};

export default EXPORT;
